import { render } from "./StreakBar.vue?vue&type=template&id=674682bb&scoped=true"
import script from "./StreakBar.vue?vue&type=script&lang=js"
export * from "./StreakBar.vue?vue&type=script&lang=js"

import "./StreakBar.vue?vue&type=style&index=0&id=674682bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674682bb"]])

export default __exports__